module.exports = "<bookings-page></bookings-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appBookings.html
// module id = 1222
// module chunks = 0